import { useLocation } from "@reach/router";
import { useEffect } from "react";
import { trackPageView } from "helpers/shopify-analytics";
// eslint-disable-next-line import/no-extraneous-dependencies
import { useShopifyCookies } from "@shopify/hydrogen-react";

const useShopifyAnalytics = () => { 
    useLocation();
    useShopifyCookies({ hasUserConsent: true, domain: ".sealskincovers.com" });

    useEffect(() => { 
        trackPageView();
    }, []);
};

export default useShopifyAnalytics;
